import React, { useEffect, useMemo } from 'react';
import * as THREE from 'three';
import { SceneState, useSceneStore } from '../../state/sceneStore';
import { useZScale } from './SceneCanvas';

interface SensorPointCloudProps {
  points: Float32Array | null;
}

const disablePointCloudRaycast = () => null;

const SensorPointCloud: React.FC<SensorPointCloudProps> = ({ points }) => {
  const pointSize = useSceneStore((state: SceneState) => state.sceneOptions.pointSize);
  const useOrthographic = useSceneStore((state: SceneState) => state.useOrthographic);
  const zScale = useZScale();

  const geometry = useMemo(() => {
    if (!points || points.length === 0) {
      return null;
    }
    const geom = new THREE.BufferGeometry();
    geom.setAttribute('position', new THREE.BufferAttribute(points.slice(), 3));
    geom.computeBoundingSphere();
    return geom;
  }, [points]);

  useEffect(() => () => geometry?.dispose(), [geometry]);

  if (!geometry) {
    return null;
  }

  const zOffset = 0.05 * zScale;
  const materialSize = pointSize * Math.sqrt(zScale) * (useOrthographic ? 0.5 : 0.03);

  return (
    <group position={[0, 0, zOffset]}>
      <points geometry={geometry} raycast={disablePointCloudRaycast}>
        <pointsMaterial
          size={materialSize}
          color="lime"
          transparent={false}
          opacity={1}
          depthTest
          depthWrite
        />
      </points>
    </group>
  );
};

export default SensorPointCloud;
